import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("serpens-cookie-consent")) {
      const t = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("serpens-cookie-consent", "accepted");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 z-50 w-[min(90vw,380px)] rounded-2xl border border-secondary/25 glass p-5 shadow-2xl shadow-black/15"
          data-testid="cookie-consent-banner"
        >
          <div className="flex items-start gap-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent/15 text-accent">
              <Cookie className="h-4 w-4" />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">We value your privacy</p>
              <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
                We use cookies to analyze traffic and improve your experience. By continuing, you consent to our use of cookies.
              </p>
              <button
                onClick={accept}
                data-testid="cookie-accept-button"
                className="mt-3 rounded-full bg-primary px-4 py-2 text-xs font-semibold text-primary-foreground transition-transform active:scale-95"
              >
                Accept & Continue
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
